import axios from "axios";
import {useCallback, useEffect, useState} from "react";
import {Broker} from "../domain/staticdata/Broker";
import {getGatewayUrl} from "../components/EnvironmentConfiguration";
import {emptyStatistics, Statistics} from "../domain/staticdata/Statistics";
import {RefreshDataFunction} from "../components/types/RefreshDataFunction";

export const useGetBroker = (): RefreshDataFunction<Broker[]> => {
    const [responseData, setResponseData] = useState<Broker[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const apiFunction = useCallback(async() => {
            setLoading(true);
            const uri = '/static-data/v1/broker';
            try {
                const response = await axios.get(getGatewayUrl() + uri);
                setResponseData(response.data as Broker[]);
            } catch (err) {
                setError(err instanceof Error ? err.message : String(err));
            } finally {
                setLoading(false);
            }
        },
        []
    );


    useEffect(() => {
            void apiFunction();
        },
        [ apiFunction ]
    );

    return { data: responseData, loading, error, apiFunction };
};

export const useSyncBroker = (): RefreshDataFunction<Statistics> => {
    const [responseData, setResponseData] = useState<Statistics>(emptyStatistics());
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const getFunction = useCallback(async () => {
            setLoading(true);
            const uri = '/static-data/v1/sync/broker';
            try {
                const response = await axios.put(getGatewayUrl() + uri);
                setResponseData(response.data as Statistics);
            } catch (err) {
                setError(err instanceof Error ? err.message : String(err));
            } finally {
                setLoading(false);
            }
        },
        []
    );

    return { data: responseData, loading, error, apiFunction: getFunction };
};
